import React, { useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";

function ConstellationCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animId;
    let dots = [];
    const DOT_COUNT = 80;
    const CONNECT_DIST = 120;
    const DOT_COLOR = "rgba(14, 165, 233, 0.35)";
    const LINE_COLOR = "rgba(14, 165, 233, 0.10)";

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    function initDots() {
      dots = [];
      for (let i = 0; i < DOT_COUNT; i++) {
        dots.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 0.4,
          vy: (Math.random() - 0.5) * 0.4,
          r: Math.random() * 2 + 1,
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < dots.length; i++) {
        const a = dots[i];
        a.x += a.vx;
        a.y += a.vy;
        if (a.x < 0 || a.x > canvas.width) a.vx *= -1;
        if (a.y < 0 || a.y > canvas.height) a.vy *= -1;

        ctx.beginPath();
        ctx.arc(a.x, a.y, a.r, 0, Math.PI * 2);
        ctx.fillStyle = DOT_COLOR;
        ctx.fill();

        for (let j = i + 1; j < dots.length; j++) {
          const b = dots[j];
          const dx = a.x - b.x;
          const dy = a.y - b.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < CONNECT_DIST) {
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.strokeStyle = LINE_COLOR;
            ctx.lineWidth = 0.7;
            ctx.stroke();
          }
        }
      }
      animId = requestAnimationFrame(draw);
    }

    resize();
    initDots();
    draw();
    window.addEventListener("resize", () => { resize(); initDots(); });

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
        pointerEvents: "none",
      }}
    />
  );
}

export default function LoginPage() {
  const { loginWithLark } = useAuth();

  return (
    <div className="login-page">
      <ConstellationCanvas />

      <div className="login-brand">
        AQUINT INFRATELE INDIA PVT LTD
        <div style={{ fontSize: 12, letterSpacing: ".18em", marginTop: 6, opacity: .75 }}>RAEBARELI BRANCH</div>
      </div>

      <div className="login-card">
        <h1>Welcome Back</h1>
        <p>Sign in to access your task management dashboard</p>

        <button
          className="btn btn-primary"
          style={{
            width: "100%",
            justifyContent: "center",
            padding: "13px",
            fontSize: 15,
            marginTop: 8,
            gap: 10,
            borderRadius: 10,
          }}
          onClick={loginWithLark}
        >
          <span style={{ fontSize: 20 }}>🔑</span>
          Continue with Lark
        </button>

        <div
          style={{
            marginTop: 24,
            paddingTop: 20,
            borderTop: "1px solid var(--border-subtle)",
            textAlign: "center",
          }}
        >
          <span style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
            Powered by Lark Base • Aquint Raebareli Task Management
          </span>
        </div>
      </div>
    </div>
  );
}
